import { RedocStandalone } from 'redoc';
import data from './oms_client_openapi.json';
import './App.css';

function App() {
  return (
    <RedocStandalone spec={data}
      options={{
        hideHostname: true
      }}
    />
  );
}

export default App;
